import { Fragment } from "react";
import {useHistory} from "react-router-dom";

import { Card, CardActionArea, CardContent, Typography } from "@mui/material";
import Grid from '@mui/material/Grid2'
import {DASHBOARD_ROUTE} from "../../lib/routes";

const REACT_APP_CLOUD_CONTROL_BASE_PATH = (window._env_ && window._env_.API_URL) ? window._env_.API_URL : process.env.REACT_APP_CLOUD_CONTROL_BASE_PATH;

export default function CategoriesGrid({siteId, categories}) {

  const history = useHistory();

  // IL RENDER DEI SERVIZI PER OGNI SITO
  const renderCardContent = ({name, icon}) => {
    return (    
      <CardContent sx={{textAlign:"center"}}>
        <img
          src={`${REACT_APP_CLOUD_CONTROL_BASE_PATH}${icon}`}
          alt={name}
          width="100%"
        />
        <Typography variant="h5" component="h2">
          {name}
        </Typography>
      </CardContent>
    );
  }

  return (
    <Fragment>
      {categories.map(({id, name, available, icon}, index) => (
        <Grid item size={{xs:12, sm:6, md:3}} key={id}>
          <Card variant="outlined">
            {available && (
              <CardActionArea
                    className={index === 0 ? "category-card": ""}
                    onClick={() => history.push(DASHBOARD_ROUTE.computePath({siteId, categoryId: id}))}>
                {renderCardContent({name, icon})}
              </CardActionArea>
            )}
            {!available && renderCardContent({name, icon})}
          </Card>
        </Grid>
      ))}
    </Fragment>
  );
}
